import {Component, OnInit} from '@angular/core';
import {RouterOutlet, RouterLink, RouterLinkActive} from '@angular/router';
import {CommonModule} from '@angular/common';
import {TranslateModule} from "@ngx-translate/core";
import {LoginComponent} from "./login/login.component";
import {HeaderComponent} from "./Main/header/header.component";
import {BusyComponent} from "./common/busy/busy.component";
import {UserRolePermissionsService} from "./common/user-role-permissions.service";
import {TopMenuComponent} from "./Main/TopMenu/top-menu/top-menu.component";
import {UserInactivityService} from "./login/UserInactivity/user-inactivity.service";
import {ReloadService} from "./reload.service";

@Component({
    selector: 'app-root',
    imports: [
        CommonModule,
        RouterOutlet,
        TranslateModule,
        BusyComponent
    ],
    standalone:true,
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})

export class AppComponent implements OnInit {
    title = 'client-app';

    constructor(
        public userRolePermissionsService: UserRolePermissionsService,
        private reloadService: ReloadService,
        userInactivityService: UserInactivityService) {
        userInactivityService.start();
    }

    async ngOnInit(): Promise<void> {
        const navigateAfterReload = this.reloadService.getPath();

        if (navigateAfterReload) {
            this.reloadService.clearPath();
            window.location.href = navigateAfterReload;
        }
    }
}
